import React from "react";
import { MdOutlineDangerous } from "react-icons/md";
import "../../styles/DeleteConfirmationModal.css";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
    if (!isOpen) return null;

    return (
        <div className="delete-confirmation-modal-overlay">
            <div className="delete-confirmation-modal-content">
                <div className="delete-confirmation-modal-header">
                    <div className="delete-confirmation-modal-header-info">
                        <h2 className="delete-confirmation-modal-title">Potwierdzenie</h2>
                    </div>
                    <button className="delete-confirmation-close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="delete-confirmation-modal-body">
                    <div className="delete-confirmation-message">
                        <div className="delete-confirmation-icon">
                            <MdOutlineDangerous />
                        </div>
                        <p className="delete-confirmation-text">
                            Czy na pewno chcesz usunąć <strong>{itemName}</strong>?
                        </p>
                        <span className="delete-confirmation-subtext">
                            Ta akcja jest nieodwracalna.
                        </span>
                    </div>
                </div>

                <div className="delete-confirmation-modal-footer">
                    <button className="delete-confirmation-cancel-btn" onClick={onClose}>
                        Anuluj
                    </button>
                    <button className="delete-confirmation-delete-btn" onClick={onConfirm}>
                        Usuń
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;